export enum EnUserType {
  Standard,
  Interface,
  QuickLink,
}
